export const environment = {
  production: false,
  mercantilUrl:
    'https://payment-gateway-frontend-test-2.desqa-ve-ocp-m3c-8x64-2a9350942ee55c9d16ed89a864995080-0000.us-south.containers.appdomain.cloud',
  returnUrl: 'https://www.google.com',
  api: 'https://mbdev.myservy.com',
  appurl: 'https://mbdev.myservy.com',
  apimyservy: 'https://mbdev.myservy.com',
  innerUrl: 'https://pay-sit.myservy.com',
  vesId: 'cfb82af5-8249-4a23-b3fd-b323af04bfe5',
  aesKeyBase64: 'RjJf4U3s7+qEo03m4EbxvwUJcvp1Z2bC7xZYqRz2E1w=',
  aesIv: '1234567890123456',
  SidneySCID: '5bb9ff65-5ff3-4d55-81cc-57670ba9507c',
};
